import { Component } from "vuety";
import { IProductGroupItem } from "../../interfaces";
import { getRoot } from "../../root";
import { BaseView } from "../base";
import { TreeItem } from "../tree/treeItem";
import Vue from "vue";

const templateElement = "v-tmpl-groupchildlist";

@Component({
  template: document.getElementById(templateElement)
    ? "#" + templateElement
    : require("./childList.html"),
  components: { "tree-item": TreeItem },
  mixins: [BaseView]
})
export class ChildListView extends Vue {
  public get groups(): IProductGroupItem[] {
    return getRoot().currentGroupChildren(this.options);
  }
}



// WEBPACK FOOTER //
// ./src/views/childlist/childlist.ts